import { render, staticRenderFns } from "./Poundage.vue?vue&type=template&id=9ba395a4&scoped=true&"
import script from "./Poundage.vue?vue&type=script&lang=js&"
export * from "./Poundage.vue?vue&type=script&lang=js&"
import style0 from "./Poundage.vue?vue&type=style&index=0&id=9ba395a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba395a4",
  null
  
)

export default component.exports